var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 235.44 152.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d1af86;\n      }\n\n      .cls-2 {\n        fill: #eb8e1c;\n      }\n\n      .cls-3 {\n        fill: #ee3731;\n      }\n\n      .cls-4 {\n        fill: #00a651;\n      }\n\n      .cls-5 {\n        stroke: #009147;\n      }\n\n      .cls-5, .cls-6, .cls-7, .cls-8 {\n        stroke-miterlimit: 10;\n        stroke-width: 2.34px;\n      }\n\n      .cls-5, .cls-8 {\n        fill: none;\n      }\n\n      .cls-6 {\n        fill: #fff;\n        stroke: #fff;\n      }\n\n      .cls-7 {\n        fill: #47ded9;\n      }\n\n      .cls-7, .cls-8 {\n        stroke: #f5e3c1;\n      }\n\n      .cls-9 {\n        fill: #ed9910;\n      }\n\n      .cls-10 {\n        fill: #e6981b;\n      }\n\n      .cls-11 {\n        fill: #d17e19;\n      }\n\n      .cls-12 {\n        fill: #f7ad34;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 117.72,
    cy: 83.3,
    rx: 116.55,
    ry: 59.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.74,97.4c3.06-.22,6.12-.44,9.18-.66,1.29-.09,2.66-.21,3.7-.98.81-.6,1.34-1.53,2.19-2.06,2.18-1.35,5.22,1.04,5.17,3.61-.04,2.57-2.18,4.67-4.51,5.73.94,1.16,1.86,2.38,2.27,3.81.4,1.43.17,3.14-.94,4.13-1.56,1.39-3.97.86-5.98.29-8.73-2.44-17.74-3.87-26.79-4.24-2.59-.11-5.29-.15-7.61-1.31-7.7-3.87-1.05-10.97,5.09-10.78,2.36.07,4.28,1.38,6.51,2,3.78,1.05,7.85.74,11.72.46Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 117.98,
    cy: 81.2,
    rx: 84.96,
    ry: 40.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.4,91.35c-.12-.16-.24-.31-.36-.45-3.77-4.28-11.68-1.19-16.89-4.01-4.43-2.4-5.51-8.5-4.16-13.35,1.35-4.85,4.49-8.97,6.74-13.48,2.25-4.5,3.58-10.05,1.18-14.47-3.41-6.29-12.07-6.96-19.21-6.48-6.28.42-12.7,1.14-18.31,3.98-8.68,4.38-15.55,12.81-19.72,21.91-3.17,4.63-5.44,9.76-5.83,15.3-.72,10.31,5.55,20.33,14.31,25.81,8.76,5.48,19.6,6.89,29.87,5.79,5.08-.54,10.2-1.66,15.25-.89,2.64.4,5.21,1.32,7.88,1.47,2.67.15,5.64-.69,7.05-2.96.87-1.4,1.01-3.12,1.36-4.73.97-4.55,3.58-9.66.85-13.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.91,35.46c-1.17.14-2.35.71-3.5,1.1-1.62.54-3.85.47-4.53-1.1-.76-1.73,1.06-3.46,2.73-4.35,1.67-.89,3.7-2.04,3.65-3.93-.67-1.6-2.6-2.24-4.33-2.37s-3.55.05-5.12-.68-2.68-2.86-1.61-4.22c-2.36-.8-4.97-.81-7.34-.03.27-1.8-.7-3.73-2.31-4.58-1.61-.86-3.75-.59-5.09.64-1.49,1.36-1.87,3.51-2.73,5.33-.86,1.82-2.86,3.55-4.7,2.75.25-1.68.02-3.44-.67-5-1.75,1.94-3.89,3.52-6.26,4.63-.57-1.67-1.42-3.24-2.51-4.62-2.26-.28-4.57,1.51-4.86,3.77-.19,1.46.37,2.89.57,4.34s-.11,3.2-1.41,3.87c-1.92,1-4.08-1.07-6.25-1.06-1.84,0-3.37,1.58-3.93,3.33s-.38,3.64-.19,5.46c-1.35-.26-2.7-.52-4.04-.77.39,1.62.78,3.24,1.17,4.87.11.47.23.96.12,1.43-.31,1.39-2.11,1.67-3.4,2.28-2.41,1.15-3.31,4.56-1.94,6.8-.09,0-.22.02-.34.04-1.46,2.01-.74,5.23,1.44,6.42-1.57.95-2.47,2.91-2.16,4.72,2.65.9,5.29,1.79,7.94,2.69-.69,1.26-1.41,2.61-1.37,4.05.04,1.44,1.15,2.96,2.59,2.89.97-.05,1.76-.75,2.67-1.08,2.84-1.03,5.76,1.74,8.77,1.49,3.45-.28,6.37-4.43,9.57-3.13,1.28.52,2.08,1.79,3.23,2.54,2.07,1.35,4.85.8,7.08-.25,2.24-1.05,4.29-2.56,6.7-3.1,2.33-.53,4.78-.1,7.16-.39s4.96-1.67,5.32-4.03c.11-.72,0-1.47.26-2.15.63-1.63,2.79-1.82,4.46-2.33,4.11-1.26,6.49-6.45,4.77-10.39,1.78-.59,3.72-.66,5.54-.19.18-2.12.36-4.23.54-6.35.1-1.21.19-2.5-.42-3.54s-2.18-1.61-3.05-.77c-.26-1.64-.53-3.28-.79-4.91-.48-.13-.96-.15-1.44-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M199.4,63.62c3.1,3.35,5.58,7.24,7.01,11.57,1.48,4.47,1.8,9.25,1.72,13.96-.04,2.21-.16,4.45-.92,6.52-.68,1.86-1.84,3.5-3.19,4.95-5.71,6.11-14.34,8.47-22.61,9.71-9.95,1.49-20.06,1.78-30.11,1.34-7.55-.33-16.05-1.62-20.72-7.35-.82-1.46-1.42-3.17-1.96-4.62-1.6-4.31-2.93-8.85-2.57-13.43.37-4.74,2.53-9.15,4.94-13.25,4.1-6.97,9.21-13.56,16.03-17.9,13.31-8.47,31.56-6.74,44.69,2,2.79,1.85,5.4,4.03,7.68,6.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M96.12,66.6c-.47-1.87-1.05-3.88.83-4.57,1.17-.36,2.87-.1,3.73-1.23,1.33-1.45-.32-4.74,1.37-5.78.54-.26,1.31-.27,1.82-.53,1.71-.99,1.16-4.44,2.97-5.29.48-.17.37-.28,1.59-.2,4.06,1.28,3.34-1.88,5.17-4.37,1-.99,1.91.15,2.65.86.97,1.08,2.23,1.89,3.39.68,1.03-1.01,2.75-2.43,4.38-1.54,1.2.58,2.44.43,3.19-.89.98-1.53,1.13-3.45,2.48-4.52,1.7-1.29,3.2,3.25,5.87,2.71l.71-.05c.83.04,1.4.82,1.81,1.47,2.03,3.1,6.35-1.81,6.98,3.24.12.33.37.98.5,1.31.37.52.74.79.75,1.72-.03.93.02,2.09.26,3.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M119.8,59.4c.38-1.23,1.17-2.33,2.21-3.09.58-.42,1.31-.75,2-.54.69.2,1.12.88,1.37,1.55.24.67.36,1.4.72,2.02s1.06,1.13,1.76.96c.42-.1.75-.43,1.12-.66s.89-.35,1.21-.06c.29.26.28.72.24,1.11-.19,1.68-.47,3.34-.85,4.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M56.11,66.03c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M54.63,61.75c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M68.13,60.1c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M62.86,71.79c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45.41,73.28c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45.39,85.66c-.06-.2-.16-.37-.3-.52-.08-.06-.16-.12-.24-.18-.18-.11-.38-.16-.59-.16h-.16c-.16,0-.31.03-.45.1-.15.05-.27.13-.38.24-.11.11-.19.23-.24.38-.07.14-.11.29-.1.45.01.1.03.21.04.31.06.2.16.37.3.52.08.06.16.12.24.18.18.11.38.16.59.16h.16c.16,0,.31-.03.45-.1.15-.05.27-.13.38-.24.11-.11.19-.23.24-.38.07-.14.11-.29.1-.45-.01-.1-.03-.21-.04-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M51.34,89.74c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M48.78,65.84c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M68.48,65.66c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M36.12,75.16c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M35.59,86.06c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M42.8,97.49c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M40.34,69.71c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M44.39,78.32c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M51.95,73.4c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M49.66,81.31c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M31.02,71.99c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M29.79,82.19c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M36.82,61.97c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M31.2,86.41c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M34.89,98.2c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M50.89,102.94c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M55.89,105.55c-.04-.09-.08-.19-.12-.28-.1-.18-.24-.32-.42-.42-.09-.04-.19-.08-.28-.12-.21-.06-.41-.06-.62,0l-.53.18c-.15.04-.29.11-.4.21-.13.08-.23.19-.3.33-.09.13-.13.28-.14.43-.03.16-.03.31.02.47.04.09.08.19.12.28.1.18.24.32.42.42.09.04.19.08.28.12.21.06.41.06.62,0,.18-.06.35-.12.53-.18.15-.04.29-.11.4-.21.13-.08.23-.19.3-.33.09-.13.13-.28.14-.43.03-.16.03-.31-.02-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M60.56,97.14c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M73.22,101.72c-.05-.15-.13-.27-.24-.38-.11-.11-.23-.19-.38-.24-.14-.07-.29-.11-.45-.1-.1.01-.21.03-.31.04-.2.06-.37.16-.52.3-.06.08-.12.16-.18.24-.11.18-.16.38-.16.59v.21c0,.16.03.31.1.45.05.15.13.27.24.38.11.11.23.19.38.24.14.07.29.11.45.1.1-.01.21-.03.31-.04.2-.06.37-.16.52-.3.06-.08.12-.16.18-.24.11-.18.16-.38.16-.59v-.21c0-.16-.03-.31-.1-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M66.91,106.04c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M83.49,104.99c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M89.36,108.76c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M92.93,95.12c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M73.62,92.39c-1.51,0-1.51,2.34,0,2.34s1.51-2.34,0-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.55,36.78c-21.76,36-10.21,82.83,25.78,104.59,36,21.76,82.83,10.22,104.6-25.78,21.76-36,10.21-82.83-25.79-104.6C116.14-10.76,69.31.77,47.55,36.78ZM77.63,134.26c-30.61-18.5-41.37-57.33-25.45-88.71l115.83,70.02c-20.39,28.68-59.77,37.2-90.38,18.7ZM173.29,106.83L57.46,36.81C77.84,8.13,117.23-.39,147.84,18.11c30.61,18.5,41.37,57.34,25.46,88.72Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFood);
export default __webpack_public_path__ + "static/media/NoFood.e59c5abd2cb5e1288b4d3639eac278c2.svg";
export { ForwardRef as ReactComponent };